import React from 'react';
import { Link } from 'react-router-dom';


const ArticleLink = ({ article, className, children }) => (
  <Link className={className} to={`/${article.slug}---${article.id}`}>
    {children}
  </Link>
);

export default ArticleLink;
